import React from 'react';
import Loading from '../Loading';
import EcgLoader from '../EcgLoader';
import styles from './AsyncContent.css';

export const LOADER_SIZE = {
  XSMALL: 'xsmall',
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large',
};

const AsyncContent = props => {
  const {
    isFetching,
    className = styles.asyncLoader,
    loader,
    children,
    size = LOADER_SIZE.SMALL,
  } = props;
  return (
    <React.Fragment>
      {isFetching ? (
        <div className={className}>
          {loader === 'ecg' ? <EcgLoader /> : <Loading size={size} />}
        </div>
      ) : (
        children
      )}
    </React.Fragment>
  );
};

export default AsyncContent;



// WEBPACK FOOTER //
// ./src/views/components/AsyncContent/AsyncContent.jsx